<template>
  <div class="main-wrapper">
    <div class="content">
      <div id="backgroundImage"></div>
      <CodesForm v-if="!isSolved" @complete="handleFormSubmit" />
      <ResultFilter v-if="isSolved" @unlockLensClick="unlockLensClick" />
      <div id="cta">
        <img src="~@/assets/images/bottom_icon.png" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { ref } from "@vue/composition-api";
// import HelloWorld from '@/components/HelloWorld.vue'
import CodesForm from "@/components/CodesForm.vue";
import ResultFilter from "@/components/ResultFilter.vue";
import { createFunctionWithTimeout } from "@/composables/utils.js";

export default {
  setup(props, context) {
    const isSolved = new ref(false);

    const handleFormSubmit = () => {
      // console.log("home handleFormSubmit");
      isSolved.value = true;
      // wait till next render for element to be in display list
      setTimeout(() => {
        window.gsap.set("#backgroundImage", { transformPerspective: 500 });
        window.gsap.to("#backgroundImage", {
          scale: 1.75,
          y: 75,
          duration: 1.0,
          // transformOrigin: "50% 50%",
          ease: "power2.inOut",
        });

        window.gsap.to(".result-filter-container", {
          opacity: "1",
          duration: "0.5",
          ease: "power2.inOut",
        });
      }, 0);
    };

    const unlockLensClick = () => {
      const exitURL = process.env.VUE_APP_LENS_EXIT_LINK;
      // console.log("unlockLensClick");
      try {
        window.gtag("event", "lens_clicked", {
          event_category: "btn_click",
          // event_label: hasCodeLabel,
          event_callback: createFunctionWithTimeout(() => {
            // console.log("now that event is recoreded lets go to site");
            // goToMainSite();
            window.location = exitURL;
          }),
        });
      } catch (e) {
        // console.log(e);
        // there was a problem, lets just go to site
        // goToMainSite();
        window.location = exitURL;
      }
    };

    // if (process.env.VUE_APP_ANALYTICS_ENABLED === "true") {
    //   console.log("tracking enabled");
    // } else {
    //   console.log("no tracking enabled");
    // }

    return {
      handleFormSubmit,
      unlockLensClick,
      isSolved,
    };
  },
  name: "Home",
  components: { CodesForm, ResultFilter },
};
</script>

<style lang="scss">
.main-wrapper {
  height: initial;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-direction: row;
  justify-content: center;
  // background: url("~@/assets/images/bg.jpg") no-repeat center center fixed;
  // -webkit-background-size: cover;
  // -moz-background-size: cover;
  // -o-background-size: cover;
  // background-size: cover;

  // transform: translate3d(0px, 0px, 0px);
  // -webkit-perspective: 500px;
  // perspective: 500px;
  // transform-style: preserve-3d;
}

#backgroundImage {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: initial;
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100);
  background: url("~@/assets/images/bg.jpg") no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;

  // -webkit-backface-visibility: hidden;
  // -webkit-transform: translateZ(0);

  // -webkit-perspective: 500px;
  // perspective: 500px;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  margin-bottom: 20px;
  width: 60%;
  max-width: 500px;
}

.result-filter-container {
  // display: none;
  // position: relative;
  opacity: 0;
  margin-bottom: 20px;
  // z-index: 1;
}

#cta {
  margin-top: 10px;
  width: 100%;
  text-align: center;
  // height: 0px;
  // padding-top: calc(51 / 365 * 100%);
  // background-image: url("~@/assets/images/bottom_icon.png");
  // background-repeat: no-repeat;
  // background-position: center center;
  // background-size: contain;
  max-width: 300px;

  img {
    width: 70%;
  }
}
</style>
